export const ANIMATION_WAIT = 500;

export const SCROLL_TRACK_TOP_OFFSET = 200;

export const TAG_NAME_TRACK_MAPPING_LEGACY = {
    gender_132: 'women',
    gender_134: 'men',
    gender_136: 'kids',
    58: 'home',
};

export enum CategoryTabIds {
    ALL = '1',
    MEN = '3',
    WOMEN = '2',
    KIDS = '4',
    HOME = '58',
}

export enum CampaignFilterTags {
    ALL = 'ALL',
    STARTING_TODAY = 'STARTING_TODAY',
    ENDING_TODAY = 'ENDING_TODAY',
}

export const CATEGORY_TAB_ID_TRACK_MAPPING = {
    [CategoryTabIds.ALL]: 'all',
    [CategoryTabIds.WOMEN]: 'women',
    [CategoryTabIds.MEN]: 'men',
    [CategoryTabIds.KIDS]: 'kids',
    [CategoryTabIds.HOME]: 'home',
};

export const TAB_SWIPE_TRACK_EVENT_NAME = 'campaignOverview_categoryTab_swipe';
export const TAB_CLICK_TRACK_EVENT_NAME = 'campaignOverview_categoryTab_click';
export const SCROLL_TRACK_EVENT_NAME = 'campaignOverview_scroll';
